import {
  messageId,
  PropertyMeta,
  ValueObjectMetaComposite,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
import { shippingDestinationNameMeta } from "../value/shipping-destination-name";
import { pickupLocationMeta } from "../value/pickup-location";
import { freeTextMeta } from "../value/free-text";
import { shippingDestinationOtherMeta } from "../value/shipping-destination-other";
/**
 * 出荷先(値オブジェクト)
 *
 *  */
export type ShippingDestination = z.infer<typeof schema>;
export type ShippingDestinationSaved = z.infer<typeof savedSchema>;
const minimalSchema = z.object({
  shippingDestinationName: shippingDestinationNameMeta.minimalSchema,
  pickupLocation: pickupLocationMeta.minimalSchema,
  postalCode: freeTextMeta.minimalSchema,
  address: freeTextMeta.minimalSchema,
  titleAndPosition: freeTextMeta.minimalSchema,
  fullName: freeTextMeta.minimalSchema,
  phoneNumber: freeTextMeta.minimalSchema,
  mailAddress: freeTextMeta.minimalSchema,
  other: shippingDestinationOtherMeta.minimalSchema,
});
const savedMinimalSchema = z.object({
  shippingDestinationName: shippingDestinationNameMeta.savedMinimalSchema,
  pickupLocation: pickupLocationMeta.savedMinimalSchema,
  postalCode: freeTextMeta.savedMinimalSchema,
  address: freeTextMeta.savedMinimalSchema,
  titleAndPosition: freeTextMeta.savedMinimalSchema,
  fullName: freeTextMeta.savedMinimalSchema,
  phoneNumber: freeTextMeta.savedMinimalSchema,
  mailAddress: freeTextMeta.savedMinimalSchema,
  other: shippingDestinationOtherMeta.savedMinimalSchema,
});
const schema = z.object({
  shippingDestinationName: shippingDestinationNameMeta.schema,
  pickupLocation: pickupLocationMeta.schema,
  postalCode: freeTextMeta.schema,
  address: freeTextMeta.schema,
  titleAndPosition: freeTextMeta.schema,
  fullName: freeTextMeta.schema,
  phoneNumber: freeTextMeta.schema,
  mailAddress: freeTextMeta.schema,
  other: shippingDestinationOtherMeta.schema,
});
const savedSchema = z.object({
  shippingDestinationName: shippingDestinationNameMeta.savedSchema,
  pickupLocation: pickupLocationMeta.savedSchema,
  postalCode: freeTextMeta.savedSchema,
  address: freeTextMeta.savedSchema,
  titleAndPosition: freeTextMeta.savedSchema,
  fullName: freeTextMeta.savedSchema,
  phoneNumber: freeTextMeta.savedSchema,
  mailAddress: freeTextMeta.savedSchema,
  other: shippingDestinationOtherMeta.savedSchema,
});
const jsonSchema = z.object({
  shippingDestinationName: shippingDestinationNameMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
  pickupLocation: pickupLocationMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
  postalCode: freeTextMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
  address: freeTextMeta.jsonSchema.nullish().transform((x) => x ?? undefined),
  titleAndPosition: freeTextMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
  fullName: freeTextMeta.jsonSchema.nullish().transform((x) => x ?? undefined),
  phoneNumber: freeTextMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
  mailAddress: freeTextMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
  other: shippingDestinationOtherMeta.jsonSchema
    .nullish()
    .transform((x) => x ?? undefined),
});
/**
 * 出荷先(値オブジェクト)のメタデータ。
 *
 *  */
export const shippingDestinationMeta = new ValueObjectMetaComposite(
  "ShippingDestination",
  "\u51FA\u8377\u5148",
  messageId("lbl.\u51FA\u8377\u5148"),
  minimalSchema,
  savedMinimalSchema,
  schema,
  savedSchema,
  jsonSchema,
  undefined,
  undefined,
  {
    shippingDestinationName: new PropertyMeta(
      "shippingDestinationName",
      "\u51FA\u8377\u5148\u540D\u79F0",
      messageId("lbl.\u51FA\u8377\u5148\u540D\u79F0"),
      "always",
      false,
      shippingDestinationNameMeta
    ),
    pickupLocation: new PropertyMeta(
      "pickupLocation",
      "\u53D7\u53D6\u5834\u6240",
      messageId("lbl.\u53D7\u53D6\u5834\u6240"),
      "always",
      false,
      pickupLocationMeta
    ),
    postalCode: new PropertyMeta(
      "postalCode",
      "\u90F5\u4FBF\u756A\u53F7",
      messageId("lbl.\u90F5\u4FBF\u756A\u53F7"),
      "always",
      false,
      freeTextMeta
    ),
    address: new PropertyMeta(
      "address",
      "\u4F4F\u6240",
      messageId("lbl.\u4F4F\u6240"),
      "always",
      false,
      freeTextMeta
    ),
    titleAndPosition: new PropertyMeta(
      "titleAndPosition",
      "\u6240\u5C5E\u30FB\u8077\u540D",
      messageId("lbl.\u6240\u5C5E\u30FB\u8077\u540D"),
      "always",
      false,
      freeTextMeta
    ),
    fullName: new PropertyMeta(
      "fullName",
      "\u6C0F\u540D",
      messageId("lbl.\u6C0F\u540D"),
      "always",
      false,
      freeTextMeta
    ),
    phoneNumber: new PropertyMeta(
      "phoneNumber",
      "\u96FB\u8A71\u756A\u53F7",
      messageId("lbl.\u96FB\u8A71\u756A\u53F7"),
      "always",
      false,
      freeTextMeta
    ),
    mailAddress: new PropertyMeta(
      "mailAddress",
      "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
      messageId("lbl.\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"),
      "always",
      false,
      freeTextMeta
    ),
    other: new PropertyMeta(
      "other",
      "\u51FA\u8377\u5148\u305D\u306E\u4ED6",
      messageId("lbl.\u51FA\u8377\u5148\u305D\u306E\u4ED6"),
      "always",
      false,
      shippingDestinationOtherMeta
    ),
  }
);
